import React from 'react'
import LoadingPlaceholder from './LoadingPlaceholder'
import CardsGrid from './CardsGrid';
import GridItem from './GridItem';
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

const LoadingCourses = () => {
  const iteration = [1, 2, 3, 4, 5]

  return (
    <>
      <ReactPlaceholder showLoadingAnimation ready={false} type="rect" style={{ width: '150px', height: '42px', margin: '42px 1.5% 0' }} />
      <CardsGrid>
        {iteration.map((_, key) => (
          <GridItem isLoading={true} index={key}>
            <LoadingPlaceholder index={key} />
          </GridItem>
        ))}
      </CardsGrid>
    </>
  )
}
export default LoadingCourses
